var helpers = require('./helpers');

function initLiveScoringMobile($page, $root) {
  var $drawer = $('#live-scoring-drawer');
  var $footer = $('#live-scoring-hole-footer');
  var $backdrop = $('.live-scoring-drawer-backdrop');

  if ($drawer.length === 0) return null;

  helpers.syncFormFieldsForLayout();

  var config = helpers.parseEntries($root);
  var state = {
    config: config,
    draft: {},
    selectedHoleIndex: 0,
    expanded: false,
  };

  function findHoleEntry(teamId, playerId, holeIndex) {
    var team = config.teams.find(function (t) {
      return String(t.teamId) === String(teamId);
    });
    if (!team) return null;
    var player = team.players.find(function (p) {
      return String(p.playerId) === String(playerId);
    });
    if (!player) return null;
    return player.holes.find(function (h) {
      return h.holeIndex === holeIndex;
    });
  }

  function initDraftFromInputs() {
    $('#live-scoring-hidden-inputs input[type="hidden"]').each(function () {
      var $input = $(this);
      var teamId = $input.data('teamId');
      var playerId = $input.data('playerId');
      var holeId = $input.data('holeId');
      state.draft[helpers.draftKey(teamId, playerId, holeId)] = $input.val();
    });
  }

  function holeIndices() {
    var indices = [];
    $page.find('.live-scoring-score-cell--hole').each(function () {
      var index = parseInt($(this).attr('data-hole-index'), 10);
      if (indices.indexOf(index) === -1) indices.push(index);
    });
    return indices.sort(function (a, b) {
      return a - b;
    });
  }

  function updateNavButtons(holeIndex) {
    var indices = holeIndices();
    if (indices.length === 0) return;
    $footer.find('.live-scoring-hole-footer__prev').prop('disabled', holeIndex <= indices[0]);
    $footer.find('.live-scoring-hole-footer__next').prop('disabled', holeIndex >= indices[indices.length - 1]);
  }

  function updateFooterFromCell($cell) {
    $footer.find('.live-scoring-hole-footer__number').text($cell.data('holeNumber'));
    $footer.find('.live-scoring-hole-footer__par').text('PAR ' + $cell.data('holePar'));
    $footer.find('.live-scoring-hole-footer__handicap').text('HDCP ' + $cell.data('holeHandicap'));
  }

  function highlightHoleColumn(holeIndex) {
    $page.find('.live-scoring-score-cell--hole').removeClass('is-selected');
    $page
      .find('.live-scoring-score-cell--hole[data-hole-index="' + holeIndex + '"]')
      .addClass('is-selected');
  }

  function selectHole($cell, options) {
    options = options || {};
    var holeIndex = parseInt($cell.attr('data-hole-index'), 10);
    state.selectedHoleIndex = holeIndex;
    updateFooterFromCell($cell);
    highlightHoleColumn(holeIndex);
    updateNavButtons(holeIndex);
    if (state.expanded) renderDrawerPlayers(holeIndex);
    if (options.expand) expandDrawer();
  }

  function selectHoleByIndex(holeIndex, options) {
    var $cell = $page
      .find('.live-scoring-score-cell--hole[data-hole-index="' + holeIndex + '"]')
      .first();
    if ($cell.length) selectHole($cell, options || {});
  }

  function expandDrawer() {
    state.expanded = true;
    $drawer.addClass('is-expanded').removeClass('is-collapsed');
    $backdrop.addClass('is-visible');
    $('body').addClass('live-scoring-drawer-open');
    renderDrawerPlayers(state.selectedHoleIndex);
  }

  function collapseDrawer() {
    state.expanded = false;
    $drawer.addClass('is-collapsed').removeClass('is-expanded');
    $backdrop.removeClass('is-visible');
    $('body').removeClass('live-scoring-drawer-open');
  }

  function drawerScoreDisplayHtml(value, par, entry) {
    var display = helpers.displayForValue(value, { par: par }, entry);

    if (display === '' || display === null || display === undefined) {
      return (
        '<div class="live-scoring-drawer-player__score mobile-app-score d-flex align-items-center justify-content-center">' +
        '<span class="live-scoring-drawer-player__value live-scoring-drawer-player__value--empty">-</span></div>'
      );
    }

    var parDiff = helpers.parDiffForValue(value, par);

    return (
      '<div class="live-scoring-drawer-player__score mobile-app-score d-flex align-items-center justify-content-center">' +
      '<div data-par-diff="' +
      parDiff +
      '"><span class="font-weight-bold">' +
      display +
      '</span></div></div>'
    );
  }

  function avatarHtml(player) {
    if (player.photoUrl) {
      return (
        '<img src="' +
        player.photoUrl +
        '" class="rounded-circle live-scoring-drawer-player__avatar" alt="">'
      );
    }
    var initials = player.name
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map(function (part) {
        return part[0].toUpperCase();
      })
      .join('');
    return (
      '<div class="rounded-circle live-scoring-drawer-player__avatar live-scoring-drawer-player__avatar--initials">' +
      '<span>' +
      initials +
      '</span></div>'
    );
  }

  function renderDrawerPlayers(holeIndex) {
    var $container = $('#live-scoring-drawer-players');
    $container.empty();

    config.teams.forEach(function (team) {
      team.players.forEach(function (player) {
        var hole = player.holes.find(function (h) {
          return h.holeIndex === holeIndex;
        });
        if (!hole) return;

        var draftValue =
          state.draft[helpers.draftKey(team.teamId, player.playerId, hole.holeId)];
        if (draftValue === undefined) draftValue = hole.initialValue;

        var editable = hole.editable;
        var controlsClass = editable
          ? 'live-scoring-drawer-player__controls'
          : 'live-scoring-drawer-player__controls live-scoring-drawer-player__controls--readonly';
        var scoreHtml = drawerScoreDisplayHtml(draftValue, hole.par, hole);

        var html =
          '<div class="live-scoring-drawer-player" data-team-id="' +
          team.teamId +
          '" data-player-id="' +
          player.playerId +
          '" data-hole-id="' +
          hole.holeId +
          '" data-hole-index="' +
          hole.holeIndex +
          '" data-editable="' +
          editable +
          '" data-par="' +
          hole.par +
          '">' +
          '<div class="live-scoring-drawer-player__header">' +
          avatarHtml(player) +
          '<div class="live-scoring-drawer-player__info">' +
          '<h6 class="text-white font-weight-bold mb-0 text-truncate">' +
          player.name +
          '</h6>' +
          '<p class="text-primary small font-weight-bold mb-0">HDCP ' +
          player.handicap +
          '</p>' +
          '</div></div>' +
          '<div class="' +
          controlsClass +
          '">' +
          '<button type="button" class="live-scoring-drawer-player__btn live-scoring-drawer-player__btn--minus" ' +
          (editable ? '' : 'disabled') +
          '><i class="mdi mdi-minus"></i></button>' +
          scoreHtml +
          '<button type="button" class="live-scoring-drawer-player__btn live-scoring-drawer-player__btn--plus" ' +
          (editable ? '' : 'disabled') +
          '><i class="mdi mdi-plus"></i></button>' +
          '<button type="button" class="live-scoring-drawer-player__btn live-scoring-drawer-player__btn--clear" ' +
          (editable ? '' : 'disabled') +
          ' aria-label="Clear score"><i class="mdi mdi-close"></i></button>' +
          '</div></div>';
        var $row = $(html);
        $container.append($row);
        updateDrawerRowControls($row);
      });
    });
  }

  function getDrawerRowDraft($row) {
    var key = helpers.draftKey($row.data('teamId'), $row.data('playerId'), $row.data('holeId'));
    if (state.draft[key] !== undefined) return state.draft[key];
    var entry = findHoleEntry($row.data('teamId'), $row.data('playerId'), $row.data('holeIndex'));
    return entry ? entry.initialValue : '';
  }

  function updateDrawerRowControls($row) {
    if ($row.attr('data-editable') !== 'true') {
      $row
        .find(
          '.live-scoring-drawer-player__btn--minus, .live-scoring-drawer-player__btn--plus, .live-scoring-drawer-player__btn--clear'
        )
        .prop('disabled', true);
      return;
    }

    var value = getDrawerRowDraft($row);
    var numeric = helpers.numericScoreValue(value);
    var isEmpty = helpers.isEmptyScoreValue(value);

    $row.find('.live-scoring-drawer-player__btn--minus').prop('disabled', false);
    $row.find('.live-scoring-drawer-player__btn--plus').prop('disabled', numeric !== null && numeric >= 19);
    $row.find('.live-scoring-drawer-player__btn--clear').prop('disabled', isEmpty);
  }

  function persistScoreChange($row, value) {
    var teamId = $row.data('teamId');
    var playerId = $row.data('playerId');
    var holeId = $row.data('holeId');
    var par = $row.data('par');
    var key = helpers.draftKey(teamId, playerId, holeId);

    state.draft[key] = value;
    $(helpers.hiddenInputSelector(teamId, playerId, holeId)).val(value);
    updateGridCell(teamId, playerId, holeId, value, par);
    updatePlayerTotal(teamId, playerId);

    var entry = findHoleEntry(teamId, playerId, $row.data('holeIndex'));
    $row.find('.live-scoring-drawer-player__score').replaceWith(drawerScoreDisplayHtml(value, par, entry));
    updateDrawerRowControls($row);
    window.unsavedChanges = true;
  }

  function parForDrawerRow($row) {
    var par = parseInt($row.data('par'), 10);
    return isNaN(par) ? 1 : par;
  }

  function adjustDrawerScore($row, delta) {
    if ($row.attr('data-editable') !== 'true') return;

    var current = getDrawerRowDraft($row);
    var par = parForDrawerRow($row);

    if (delta > 0) {
      if (current === 'X') {
        persistScoreChange($row, '1');
        return;
      }

      var numeric = helpers.numericScoreValue(current);
      if (numeric !== null && numeric >= 19) return;

      if (numeric === null) {
        persistScoreChange($row, String(par));
        return;
      }

      persistScoreChange($row, String(numeric + 1));
      return;
    }

    if (current === 'X') {
      persistScoreChange($row, '');
      return;
    }

    var score = helpers.numericScoreValue(current);
    if (score === null) {
      persistScoreChange($row, String(par));
      return;
    }

    if (score === 1) {
      persistScoreChange($row, helpers.allowX() ? 'X' : '');
      return;
    }

    persistScoreChange($row, String(score - 1));
  }

  function updateGridCell(teamId, playerId, holeId, value, par) {
    var $cell = $page.find(
      '.live-scoring-score-cell--hole[data-team-id="' +
        teamId +
        '"][data-player-id="' +
        playerId +
        '"][data-hole-id="' +
        holeId +
        '"]'
    );
    if ($cell.length === 0) return;

    var entry = findHoleEntry(teamId, playerId, parseInt($cell.attr('data-hole-index'), 10));
    var display = helpers.displayForValue(value, { par: par }, entry);
    var parDiff = helpers.parDiffForValue(value, par);

    if (display === '' || display === null || display === undefined) {
      $cell.html('<span class="live-scoring-score-cell__value"></span>');
      return;
    }

    $cell.html(helpers.parDiffDisplayHtml(display, parDiff));
  }

  function updatePlayerTotal(teamId, playerId) {
    var $row = $page.find(
      '.live-scoring-player-row[data-team-id="' + teamId + '"][data-player-id="' + playerId + '"]'
    );
    if ($row.length === 0) return;

    var total = 0;
    $row.find('.live-scoring-score-cell--hole').each(function () {
      var $cell = $(this);
      var holeId = $cell.data('holeId');
      var par = $cell.data('holePar');
      var $input = $(helpers.hiddenInputSelector(teamId, playerId, holeId));
      if ($input.length === 0) return;
      total += helpers.scoreValueForTotal($input.val(), par);
    });

    $row.find('.live-scoring-score-cell--total .live-scoring-score-cell__value').text(total);
  }

  initDraftFromInputs();

  $('#live-scoring-hidden-inputs input[type="hidden"]').each(function () {
    var $input = $(this);
    updateGridCell(
      $input.data('teamId'),
      $input.data('playerId'),
      $input.data('holeId'),
      $input.val(),
      $input.data('holePar')
    );
  });

  $page.find('.live-scoring-player-row').each(function () {
    var $row = $(this);
    updatePlayerTotal($row.data('teamId'), $row.data('playerId'));
  });

  var $firstHoleCell = $page.find('.live-scoring-score-cell--hole').first();
  if ($firstHoleCell.length) selectHole($firstHoleCell);

  $page.off('click.liveScoringHole', '.live-scoring-score-cell--hole');
  $page.on('click.liveScoringHole', '.live-scoring-score-cell--hole', function () {
    selectHole($(this), { expand: true });
  });

  $footer.off('click.liveScoringHole', '.live-scoring-hole-footer__prev');
  $footer.on('click.liveScoringHole', '.live-scoring-hole-footer__prev', function (e) {
    e.stopPropagation();
    selectHoleByIndex(state.selectedHoleIndex - 1);
  });

  $footer.off('click.liveScoringHole', '.live-scoring-hole-footer__next');
  $footer.on('click.liveScoringHole', '.live-scoring-hole-footer__next', function (e) {
    e.stopPropagation();
    selectHoleByIndex(state.selectedHoleIndex + 1);
  });

  $drawer.off('click.liveScoringDrawer', '.live-scoring-drawer__handle');
  $drawer.on('click.liveScoringDrawer', '.live-scoring-drawer__handle', function () {
    if (state.expanded) collapseDrawer();
    else expandDrawer();
  });

  $footer.off('click.liveScoringDrawer', '.live-scoring-hole-footer__center');
  $footer.on('click.liveScoringDrawer', '.live-scoring-hole-footer__center, .live-scoring-hole-footer__info', function (e) {
    e.stopPropagation();
    if (!state.expanded) expandDrawer();
  });

  $backdrop.off('click.liveScoringDrawer');
  $backdrop.on('click.liveScoringDrawer', function () {
    collapseDrawer();
  });

  $drawer.off('click.liveScoringDrawer', '.live-scoring-drawer-player__btn--minus');
  $drawer.on('click.liveScoringDrawer', '.live-scoring-drawer-player__btn--minus', function () {
    adjustDrawerScore($(this).closest('.live-scoring-drawer-player'), -1);
  });

  $drawer.off('click.liveScoringDrawer', '.live-scoring-drawer-player__btn--plus');
  $drawer.on('click.liveScoringDrawer', '.live-scoring-drawer-player__btn--plus', function () {
    adjustDrawerScore($(this).closest('.live-scoring-drawer-player'), 1);
  });

  $drawer.off('click.liveScoringDrawer', '.live-scoring-drawer-player__btn--clear');
  $drawer.on('click.liveScoringDrawer', '.live-scoring-drawer-player__btn--clear', function () {
    persistScoreChange($(this).closest('.live-scoring-drawer-player'), '');
  });

  return state;
}

function destroyLiveScoringMobile() {
  var $page = $('.controller-public-hotsites-live-scorings.action-index');
  var $drawer = $('#live-scoring-drawer');
  var $footer = $('#live-scoring-hole-footer');
  var $backdrop = $('.live-scoring-drawer-backdrop');

  $page.off('.liveScoringHole');

  if ($footer.length) {
    $footer.off('.liveScoringHole');
    $footer.off('.liveScoringDrawer');
  }

  if ($drawer.length) {
    $drawer.off('.liveScoringDrawer');
    $drawer.removeClass('is-expanded').addClass('is-collapsed');
  }

  if ($backdrop.length) {
    $backdrop.off('.liveScoringDrawer');
    $backdrop.removeClass('is-visible');
  }

  $('body').removeClass('live-scoring-drawer-open');
}

module.exports = initLiveScoringMobile;
module.exports.destroy = destroyLiveScoringMobile;
